/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime (time, cFormat) {
  if (arguments.length === 0)
  {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object')
  {
    date = time
  } else
  {
    if (typeof time === 'string' && /^[0-9]+$/.test(time))
    {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10)
    {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a')
    {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}
// 16进制 转 10进制
export function hex2int (hex) {
  if (hex)
  {
    const size = hex.slice(1)
    var len = size.length
    var a = new Array(len)
    var code
    for (var i = 0; i < len; i++)
    {
      code = size.charCodeAt(i)
      if (code >= 48 && code < 58)
      {
        code -= 48
      } else
      {
        code = (code & 0xdf) - 65 + 10
      }
      a[i] = code
    }
    return a.reduce(function (acc, c) {
      acc = 16 * acc + c
      return acc
    }, 0)
  }
}

// 10进制 转 16进制
export function int2hex (num, width) {
  var hex = '0123456789abcdef'
  var s = ''
  while (num)
  {
    s = hex.charAt(num % 16) + s
    num = Math.floor(num / 16)
  }
  if (typeof width === 'undefined' || width <= s.length)
  {
    return s
  }
  var delta = width - s.length
  var padding = ''
  while (delta-- > 0)
  {
    padding += '0'
  }
  return padding + s
}
// 生成全球唯一标识GUID （参考：https://blog.csdn.net/Alive_tree/article/details/87942348）
export function createGguid () {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

// 身份证格式验证
export function IdCodeValid (code) {
  //身份证号合法性验证
  //支持15位和18位身份证号
  //支持地址编码、出生日期、校验位验证
  var city = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江 ',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北 ',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏 ',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外 '
  }
  var row = {
    pass: true,
    msg: '验证成功'
  }
  if (
    !code ||
    !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(
      code
    )
  )
  {
    row = {
      pass: false,
      msg: '身份证号格式错误'
    }
  } else if (!city[code.substr(0, 2)])
  {
    row = {
      pass: false,
      msg: '身份证号地址编码错误'
    }
  } else
  {
    //18位身份证需要验证最后一位校验位
    if (code.length == 18)
    {
      code = code.split('')
      //∑(ai×Wi)(mod 11)
      //加权因子
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      //校验位
      var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
      var sum = 0
      var ai = 0
      var wi = 0
      for (var i = 0; i < 17; i++)
      {
        ai = code[i]
        wi = factor[i]
        sum += ai * wi
      }
      if (parity[sum % 11] != code[17].toUpperCase())
      {
        row = {
          pass: false,
          msg: '身份证号校验位错误'
        }
      }
    }
  }
  return row
}

/**
 * 将base64转换为文件
 *
 * @export
 * @param {string} base64 带前缀的base64
 * @param {string} filename 最终保存的文件名
 * @return {blob}  文件流
 */
export function dataURLtoFile (base64, filename) {
  var arr = base64.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--)
  {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}


// 关闭界面，整合微信/钉钉的关闭动作
export function allClose () {
  try
  {
    // 微信关闭
    WeixinJSBridge.invoke('closeWindow', {}, function (res) { })
  } catch { }
  try
  {
    // 钉钉关闭 （非ios）
    dd.biz.navigation.close({
      onSuccess: () => { }
    })
  } catch { }
  try
  {
    // 钉钉关闭 （ios）
    dd.biz.navigation.quit({
      message: 'quit message', //退出信息，传递给openModal或者openSlidePanel的onSuccess函数的result参数
      onSuccess: function (result) {
        /**/
      },
      onFail: function () { }
    })
  } catch { }
  // 普通浏览器关闭
  window.close()
}



